import React, { createContext, useContext, useState, useCallback } from 'react';
// import SpinnerLoader from '../components/Shared23/SpinnerLoader';

const LoaderContext = createContext({
  loading: false,
  showLoader: () => { },
  hideLoader: () => { }
});

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoader = useCallback(() => setLoading(true), []);
  const hideLoader = useCallback(() => setLoading(false), []);


  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}

      {/* Spinner Overlay - Shows if either loading or gridLoading is true */}
      {(loading) && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-brandRed"></div>
        </div>
      )}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);

export default LoaderContext;
